<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M21.6366 1.36338C20.5688 0.29554 18.8375 0.29554 17.7696 1.36338L16.5643 2.56875L20.4313 6.43574L21.6366 5.23037C22.7045 4.16253 22.7045 2.43122 21.6366 1.36338Z"
                :fill="color" 
            />
            <path
                d="M19.3264 7.5406L15.4594 3.67361L2.8023 16.3307C2.15981 16.9732 1.68753 17.7657 1.42814 18.6365L0.595033 21.4332C0.513137 21.7081 0.588499 22.0058 0.791342 22.2087C0.994185 22.4115 1.29188 22.4869 1.56681 22.405L4.36357 21.5719C5.23437 21.3125 6.02682 20.8402 6.6693 20.1977L19.3264 7.5406Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgPencil',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>